<script lang="ts">
  interface Props {
    kind: 'project' | 'task' | 'into';
  }

  let { kind }: Props = $props();
</script>

{#if kind === 'project'}
  <svg
    class="type-icon"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path
      d="M2.75 5.1V12a1.25 1.25 0 0 0 1.25 1.25h8a1.25 1.25 0 0 0 1.25-1.25V6.35A1.1 1.1 0 0 0 12.15 5.25H8.2L6.85 3.9a1.1 1.1 0 0 0-.78-.32H4A1.25 1.25 0 0 0 2.75 4.83V5.1z"
    />
  </svg>
{:else if kind === 'into'}
  <svg
    class="type-icon into-icon"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M5 2.75v7.5h7.25" />
    <path d="M9.75 7.75 12.5 10.25 9.75 12.75" />
  </svg>
{:else}
  <svg
    class="type-icon"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <rect x="2.75" y="2.75" width="10.5" height="10.5" rx="2" />
    <path d="M5.25 8.15 7.1 10l3.65-3.85" />
  </svg>
{/if}

<style>
  .type-icon {
    display: block;
    width: 1rem;
    height: 1rem;
  }

  .into-icon {
    width: 0.75rem;
    height: 0.75rem;
  }
</style>
